import api from "@/lib/api";

const CHUNK_SIZE = 4 * 1024 * 1024; // 4 MB — small enough to sail through the proxy

/**
 * Upload a video reliably by splitting it into small chunks (works for large phone
 * clips on mobile networks where a single big request stalls). The server reassembles
 * the chunks, downscales to 720p and returns { url, poster, type }.
 * @param {File} file
 * @param {(pct:number)=>void} [onProgress] 0–100 upload progress
 */
export async function uploadVideoChunked(file, onProgress) {
    const init = await api.post("/uploads/video-chunk/init", (() => {
        const fd = new FormData();
        fd.append("filename", file.name || "clip.mp4");
        return fd;
    })(), { headers: { "Content-Type": "multipart/form-data" } });
    const uploadId = init.data.upload_id;

    const total = Math.max(1, Math.ceil(file.size / CHUNK_SIZE));
    for (let i = 0; i < total; i++) {
        const blob = file.slice(i * CHUNK_SIZE, (i + 1) * CHUNK_SIZE);
        const fd = new FormData();
        fd.append("index", String(i));
        fd.append("chunk", blob, "chunk");
        await api.post(`/uploads/video-chunk/${uploadId}`, fd, {
            headers: { "Content-Type": "multipart/form-data" },
            timeout: 120000,
        });
        if (onProgress) onProgress(Math.round(((i + 1) / total) * 100));
    }

    // Reassemble + transcode on the server (can take a bit for longer clips).
    const done = await api.post(`/uploads/video-chunk/${uploadId}/complete`, {}, { timeout: 180000 });
    return done.data; // { url, poster, type }
}
